export const MIN_SEARCH_SYMBOLS = 2
export const ROWS_PER_PAGE_OPTIONS = [10, 20, 30, 40, 50]

/* for cases when we want to hide sorting in table */
export const TABLE_EMPTY_SORT_BY = { id: '', desc: undefined }
